/**
 * Le refus d'un GESTE de la page « Exports » (télécharger, relancer, supprimer),
 * dit dans la langue de l'ÉCRAN.
 *
 * 🔴 Relevé par la passe de doc 7e : un téléchargement ou une relance refusés
 * faute de droit affichaient la phrase BRUTE du serveur, en anglais,
 * « Permission 'clients:manage_pricing' required for this action » — celle de
 * `_require_admin_permission` et du contenu d'un fichier
 * (`_exports_droits_du_fichier`). Le toast (`toastApiError`) ne consultait pas la
 * table TRANSVERSE (`api-error-transverse.ts`), qui dit ce refus PAR SON CODE.
 *
 * L'ordre, celui des autres lecteurs de refus d'export (`refusDeLExportVcard.ts`,
 * `BulkExportDialog.tsx`) ; lu aussi par `useGedExport.ts` (export du coffre, et
 * « Préparer le pli » d'un appel d'offres) :
 * 1. un INCIDENT (5xx) garde le toast du socle — phrase d'incident traduite, et la
 *    référence avec « Copier », que le support demande ;
 * 2. la table TRANSVERSE (droit manquant, introuvable, entité hors périmètre…) ;
 * 3. sinon la phrase du serveur, que le centre rédige déjà dans la langue envoyée
 *    (`?lang=` de la relance : « trop d'exports en cours », « relance impossible »).
 *
 * ⚠️ Ne marche que si le refus garde son CODE : les appels de `lib/api/exports.ts`
 * lèvent une `ApiError` (`handleApiError`), plus un `Error` nu.
 */

import type { TFunction } from 'i18next'
import { toast } from 'sonner'

import { estUnIncident, phraseDeRefusTransverse } from '@/lib/api-error-transverse'
import { toastApiError } from '@/lib/toast-error'

export function direLeRefusDUnGesteDExport(err: unknown, repli: string, t: TFunction): void {
    const transverse = estUnIncident(err) ? null : phraseDeRefusTransverse(err, t)
    if (transverse) {
        toast.error(transverse)
        return
    }
    toastApiError(err, repli)
}
